import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Bell, AlertCircle } from "lucide-react";

export default function TumNotifications() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <PageHeader 
        title="Notifications" 
        description="In-app notifications, email templates, and alert rules"
      />
      
      <Card className="p-12 text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="h-20 w-20 rounded-full bg-muted flex items-center justify-center">
            <Bell className="h-10 w-10 text-muted-foreground" />
          </div>
          <h3 className="text-2xl font-semibold">Notifications Module</h3>
          <p className="text-muted-foreground max-w-md">
            This module is under construction. Configure notification templates, 
            alert rules, and manage in-app notification center.
          </p>
          <div className="flex items-center gap-2 text-sm text-amber-600 bg-amber-50 px-4 py-2 rounded-md">
            <AlertCircle className="h-4 w-4" />
            <span>Coming soon: MJML template editor and alert rule builder</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
